/* eslint-disable no-console */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React, { useContext } from 'react';
import { MenuItem } from '@mui/material';
import { BsFolder } from 'react-icons/bs';
import { LanguageContext } from '../../../../libs/Context';
import { roleCondition } from '../../../../libs/HelperContent';
import { useSelector } from 'react-redux';
import useUpdateStorage from '../../../LicenseSubscription/customHooks/useGetStorage';
import { MediaContext } from '../..';
import PropTypes from 'prop-types';

const UploadFolder = (props) =>
{
	const { uploadFolderFunc, setOpen, setMediaState, tab } = props;
	const { language } = useContext(LanguageContext);
	const userData = useSelector((state) => state?.mysession?.session);
	const { clickedData } = useContext(MediaContext);
	const setStorageData = useUpdateStorage();

	const handleUpload = async (e) =>
	{
		const fileList = Array.from(e.target.files);
		const size = fileList.reduce((total, item) => total + item?.size, 0);
		const checkRole = roleCondition(userData?.empRole);

		const ownerCompanyId = tab === 1 ? clickedData?.companyId : userData?.companyId;

		setStorageData({ action: 'add', size, ownerCompanyId })
			.then((lic) =>
			{
				if (lic)
				{
					if (lic?.statusCode === 507)
					{
						setOpen(checkRole && true);
					}
					else
					{
						uploadFolderFunc(fileList);
					}
				}
				setMediaState({ type: 'setMenuItems', payload: { create: 0 } });
			});
	};

	return (
		<MenuItem className='menucard noPdng'>
			<div className='flexRow positionRelative'>
				<input
					className='uploadInput'
					id='folderType'
					type='file'
					title={language?.uploadFolder}
					value=''
					onChange={handleUpload}
					webkitdirectory=''
					multiple
				/>
				<label htmlFor='folderType' className='flexRow'>
					<span className='flexInline pointer menuIconPdng'>
						<BsFolder fontSize={'var(--pixel24)'} className='lightTxt'/>
						<span className='pdngLXS'>{language?.uploadFolder}</span>
					</span>
				</label>
			</div>
		</MenuItem>
	);
};

UploadFolder.propTypes = {
	uploadFolderFunc : PropTypes.func,
	setOpen          : PropTypes.func,
	setMediaState    : PropTypes.func,
	tab              : PropTypes.number
};

export default UploadFolder;